var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetaiconelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238,214.15l-26.53,48c-8.09,14.65-15.46,30.2-25.21,43.84-8.05,11.26-20.77,22.36-35.73,20.14C135.79,324,132,307.71,130.2,295.24a150.19,150.19,0,0,1,14.92-89.35c3.4-6.61,7.14-13.58,11.83-19.37,5.72-7.07,11.64-5.4,18.9-1.18,14,8.15,26.89,18.67,38.42,30,38.09,37.54,63.35,98.18,118.1,115.16,12.48,3.87,27.07,4.48,38.83-2,12.57-6.89,18.05-20.44,18.94-34.14,2.07-31.84-14.58-63.25-30.49-89.6-15.15-25.1-36-52.57-68.83-49.51-28,2.61-51.49,23.72-55.2,51.76-.66,5,4.75,9.25,9.3,9.3,5.57.06,8.65-4.34,9.31-9.3,2.86-21.67,28.49-37.57,49.27-32.52,13,3.15,22.76,13.69,30.19,24.24a300.94,300.94,0,0,1,23.86,40.61c8.14,16.57,30,71.24-3,75.26-26,3.17-50.66-20.9-66.33-38.57-18.28-20.61-33.19-44-51.69-64.41a238,238,0,0,0-35.67-32c-11.45-8.41-26.48-20-41.7-16.43-13.9,3.28-22,18.25-28.29,29.83a169.2,169.2,0,0,0-15.94,41.38c-6.52,27.29-8.61,61.7,3.67,87.75a38.71,38.71,0,0,0,36.29,22.65c16.43-.4,31-9.22,41.39-21.55,11.37-13.5,19.14-29.77,27.63-45.13l30.22-54.68c5.8-10.49-10.27-19.88-16.07-9.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaiconelement);
export default __webpack_public_path__ + "static/media/meta icon element.46f57ca3685101c6f8ede359d55a6813.svg";
export { ForwardRef as ReactComponent };